import { ArrowIcon } from "../../../../../../../shared/infrastructure";
import React from "react";

type StepProps = {
  title: string;
  subtitle?: React.ReactNode;
  prevStep?: () => void;
  children: React.ReactNode;
  actions?: React.ReactNode;
};

export const Step = ({
  title,
  subtitle,
  prevStep,
  children,
  actions,
}: StepProps): React.ReactElement => {
  return (
    <section className="grid gap-[20px] p-[24px]">
      {!!prevStep && (
        <button onClick={prevStep}>
          <ArrowIcon width={20} height={20} className="rotate-90" />
        </button>
      )}
      <section className="grid gap-[10px]">
        <h1 className="text-[20px]">{title}</h1>
        {!!subtitle && <p className="text-[14px]">{subtitle}</p>}
      </section>
      {children}
      {actions}
    </section>
  );
};
